<template lang="">

        <!-- Basic modal -->
    <div id="modal_default" class="modal fade" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{modalContentTitle}}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
    
            <div class="modal-body" v-html="modalContentHtml">
              
            </div>
    
            <div class="modal-footer">
              <button type="button" class="btn btn-link" data-bs-dismiss="modal">Close</button>
              <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
            </div>
          </div>
        </div>
      </div>
      <!-- /basic modal -->
    
</template>
<script>

//! Modal'ı açmak için ya ModalOpen methodunu kullanırız ya da aşağıdaki gibi buton otomatik açabilir.
//! <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#modal_default" >Launch <i class="ph-play-circle ms-2"></i></button>

// Setup module
import { Modal } from "bootstrap"

export default {
  data() {
    return {
      modalContentHtml: "",
      modalContentTitle: ""
    }
  },
  methods: {
    ModalOpen(param) {
      this.modalContentHtml = param?.modalContentHtml;
      this.modalContentTitle = param.modalContentTitle;
      var myModal = new Modal(document.getElementById('modal_default'));
      myModal.show();
    }
  },
}
</script>
<style lang="">

</style>